import type { TourStep } from '../types';

export const designerStatsSteps: TourStep[] = [
  { target: '[data-tour="designer-stats-workload"]', title: 'Текущая нагрузка', content: 'Посмотрите, сколько заданий сейчас находится в работе.' },
  { target: '[data-tour="designer-stats-earnings"]', title: 'Заработок', content: 'Сводка начислений помогает оценить результат за период.' },
  { target: '[data-tour="designer-stats-by-day"]', title: 'Динамика по дням', content: 'График показывает, как менялась выполненная работа.' },
  { target: '[data-tour="designer-stats-by-type"]', title: 'Макеты по типам', content: 'Распределение помогает увидеть основные типы выполненных макетов.' },
];
